import Entity from '../entity'

export default class WorkshopInfo extends Entity<number>{
    dealer_id: number;
    manufacturer_id: number;
    employee_id: number;
    function_id: number;
    firstname: string;
    lastname: string;
    city: string;
    phone: string;
    movil: string;
    email: string;
    birthdate: string;
}


